import en from "./en"
// import es from "./es"
// import _hi from "./_hi"

const langs = {
    en: en,
    // es: es,
    // _hi: _hi,
}

export default langs;
